<ng-template [ngIf]="!isForgotPasswordForm">
  <h3 class="small-30">Log into your account</h3>
  <form class="signup-form" [formGroup]="form" (ngSubmit)="onLogin()">
    <p class="label">
      Email
    </p>
    <input formControlName="email" type="email" class="form-control s-form-field" placeholder="Enter Your Email Address" />
    <span *ngIf="form.get('email').touched || form.get('email').dirty">
      <span class="error" *ngIf="form.get('email').hasError('required')">This field is required</span>
      <span class="error" *ngIf="form.get('email').hasError('email')">Email is invalid</span>
    </span>
      <p class="label">
        Password
      </p>
      <input type="password" formControlName="password" class="form-control s-form-field" placeholder="Enter Your Password" />
      <span *ngIf="form.get('password').touched || form.get('password').dirty">
        <span class="error" *ngIf="form.get('password').hasError('required')">This field is required</span>
        <span class="error" *ngIf="form.get('password').hasError('minlength')">Minimum 06 characters are allowed</span>
      </span>
      <p class="small-text">Don't have an Account? <a (click)="signUpForm()" class="cursor-pointer">Sign up</a> </p>
      <p class="small-text pull-right"><a (click)="forgotPasswordForm()" class="cursor-pointer">Forgot Password?</a> </p>
    <!-- <p class="small-text f-light" style="font-size:16px">By joining you agree with our terms and privacy policy</p> -->
    <button type="submit" class="btn btn-01 mt-4  new-btn bg-black" [disabled]="loginProcessing">
      <app-preloader *ngIf="loginProcessing" [size]="'sm'"></app-preloader>
      <span *ngIf="!loginProcessing" class="cursor-pointer">Log In</span>
    </button>
  </form>
</ng-template>

<ng-template [ngIf]="isForgotPasswordForm">
  <h3 class="small-30">Forgot Password</h3>
  <form class="signup-form" [formGroup]="form" (ngSubmit)="onForgot()">
    <p class="label">
      Email
    </p>
    <input formControlName="email" type="email" class="form-control s-form-field"
      placeholder="Enter Your Email Address" />
    <span *ngIf="form.get('email').touched || form.get('email').dirty">
      <span class="error" *ngIf="form.get('email').hasError('required')">This field is required</span>
      <span class="error" *ngIf="form.get('email').hasError('email')">Email is invalid</span>
    </span>
    <p class="small-text">Remember Password? <a (click)="loginForm()" class="cursor-pointer">Log In</a> </p>
    <button type="submit" class="btn btn-01 mt-4  new-btn" [disabled]="loginProcessing">
      <app-preloader *ngIf="loginProcessing" [size]="'sm'"></app-preloader>
      <span *ngIf="!loginProcessing" class="cursor-pointer">Send Reset Link</span>
    </button>
  </form>
</ng-template>
